module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-supplier-detail"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_supplier_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Supplier')))])], 1), _vm._m(0)]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("サプライヤー詳細")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.name')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.name))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.name_hurigana')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.name_hurigana))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.responsible_name')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.responsible_name))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.tel_no')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.tel_no))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.fax_no')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.supplier.fax_no) ? _c('span', [_vm._v(_vm._s(_vm.supplier.fax_no))]) : _c('span', [_vm._v("登録なし")])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.mail')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(_vm.supplier.mail) ? _c('span', [_vm._v(_vm._s(_vm.supplier.mail))]) : _c('span', [_vm._v("登録なし")])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.postal_code')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.postal_code))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.address')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.address))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('supplier.label.order_method')))])])])]), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.displayOrderMethod))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(1), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.displayFeeType))])])])])]), _c('div', {
    staticClass: "row margin-top margin-bottom"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v("サプライヤー詳細")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("発送手数料")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fc6f195!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-supplier-detail.pug
// module id = 874
// module chunks = 1